import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize, map } from 'rxjs/operators';
import { Activity, ConfigurationApi, LookupApi, LookupField } from '../core/api.gen';
import { CommonService } from '../core/common.service';
import { DialogService } from '../core/dialog.service';
import { LoaderService } from '../core/loader.service';
import { LookupTypeKeys } from '../shared/lookup-type-keys';

@Component({
  selector: 'eos-task-amendment',
  templateUrl: './task-amendment.component.html',
  styleUrls: ['./task-amendment.component.scss']
})
export class TaskAmendmentComponent implements OnInit {
  activities: Activity[] = [];


  activityFilter = new UntypedFormGroup({
    employeeCategory: new UntypedFormControl(null, [Validators.required]),
    pbType: new UntypedFormControl(null, [Validators.required]),
    country: new UntypedFormControl(null, [Validators.required]),
    isCandidate: new UntypedFormControl(true, [Validators.required]),
    isWSO: new UntypedFormControl(false, [Validators.required]),
  });

  pbTypes = [];
  countries = [];
  employeeCategories = [];

  activityTypes = [
    {
      id: 100,
      displayText: 'Email',
      disabled: true
    },
    {
      id: 101,
      displayText: 'Profile update',
    },
    {
      id: 102,
      displayText: 'External',
      disabled: true
    },
    {
      id: 103,
      displayText: 'Request',
      disabled: true
    },
    {
      id: 106,
      displayText: 'Status Request',
      disabled: true
    }
  ];

  constructor(
    private configurationService: ConfigurationApi,
    private common: CommonService,
    private lookupApi: LookupApi,
    private loader: LoaderService,
    private dialogService: DialogService) { }

  ngOnInit() {
    this.loadFilterData();
  }

  get showControl() {
    if (this.activityFilter.getRawValue().employeeCategory) {

      return ((this.activityFilter.getRawValue().employeeCategory.id === 717)||(this.activityFilter.getRawValue().employeeCategory.id ==5972 &&this.activityFilter.getRawValue().country!=(null||undefined) &&this.activityFilter.getRawValue().country.id ==13410));
    }
    return false;
  }
  loadFilterData() {
    // preboarding types, // some extra ID from transfer type is also in column hence aded
    this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.ONBOARDING_TYPES])
      .subscribe(resp => {
        this.pbTypes = resp;
      });

    // countries
    this.lookupApi.getLookupFieldsByType(LookupTypeKeys.OFFICE_LOCATION_COUNTRY, 0, 0)
      .subscribe(resp => this.countries = resp);

    // employeeCategories
    this.lookupApi.getLookupFieldsByType(LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES, 0, 0)
      .subscribe(resp => {
        this.employeeCategories = resp;
      });
  }

  onSubmit() {
    this.getActivities();
  }

  getActivities() {
    if (this.activityFilter.valid) {
      this.loader.show();
      this.configurationService.activitiesForAmend(this.activityFilter.getRawValue())
        .pipe(
          finalize(() => this.loader.clear()))
        .subscribe(resp => {
          resp.map(act => {
            act['activityTypeString'] = this.activityTypes.find(a => a.id === act.activityType).displayText;
            return act;
          });
          this.activities = resp;
        });
    }
  }

  editActivity(activity: Activity) {
    this.dialogService.showActivityAmendEdit(activity, this.countries)
      .result.then(resp => {
        this.getActivities();
      }, dismiss => {
        this.getActivities();
      });
  }

  clearForm() {
    this.activityFilter.reset();
    this.activityFilter.patchValue({ isCandidate: true });
    this.activities = [];
  }

  createActivity() {
    this.dialogService.showActivityAmendCreate(this.employeeCategories, this.countries, this.pbTypes, this.activityTypes)
      .result.then(resp => {
        this.getActivities();
      }, dismiss => {
        this.getActivities();
      });
  }

  setWIT() {
    this.activityFilter.patchValue({ isWSO: false });
  }

  cloneActivity(activity: Activity) {
    this.dialogService.showActivityAmendCreate(
      this.employeeCategories, 
      this.countries, this.pbTypes, 
      this.activityTypes,
       activity,
        this.activityFilter.value.isWSO)
      .result.then(resp => {
        this.getActivities();
      }, dismiss => {
        this.getActivities();
      });
  }

}
